export default __webpack_public_path__ + "static/media/contact_1.2e16d3ae.png";